/**
 * Used in a product for formatting retrieved values from a field.
 * @param {Object} product
 */
var Formatter = function(product)
{

	var _this = this;

	this.product = product;

	this._default = {
		get: function(elm){
			return elm.val();
		},
		set: function(elm, value){
			// Default do nothing
		}
	}

	/**
	 * Format a number, nothing to format here except some rounding: 5.5 -> 5
	 */
	this.number = {
		get: function(elm){
			return elm.val();
		},
		set: function(elm, value){
			elm.val(Math.round(value));
		}
	}

	/**
	 * Format a money value, the euro: 5 -> €5
	 */
	this.euro = {
		get: function(elm){

			// Replace the euro character and the dots for empty characters
			var val = elm.val().replace('€', '').replace(/\./g, '');

			// Check if there is no comma in the string
			if(val.toString().indexOf(",") !== -1)
				val = val.split(",")[0];

			// Make a number of the value
			parseInt(val);

			// When it is not a value return 'nothing'
			if(isNaN(val))
				return "";

			// Otherwise return the right value
			return val == 0 ? "" : val;
		},
		set: function(elm, value){
			value = $().number_format(Math.round(value), {numberOfDecimals: 0, decimalSeparator: ',', thousandSeparator: '.'});
			elm.val('€' + value);
		}
	}

	/**
	 * Format a number to display them as months: 5 -> 5 maanden
	 */
	this.months = {
		get: function(elm){
			return Number(elm.val().replace(' maanden', ''));
		},
		set: function(elm, value){
			elm.val(Math.round(value) + ' maanden');
		}
	}

	/**
	 * Advanced holder for a certain element for a doorlopend krediet
	 */
	this.dk = {

		/**
		 * A holder for using a select
		 */
		select: {

			/**
			 * Generates the options of the select needs to be done only on certain moment, not always
			 * @param {Object} fields
			 * @param {Object} callback
			 */
			generate: function(fields, callback){

				_this.dk.select.looptijd.options = {};
				_this.dk.select.maandlast.options = {};

				_this.dk.select.maandlast.values = []
				_this.dk.select.looptijd.values = [];

				// Loop through three options and calculate the common maandlast and looptijd values
				for(var i = 0; i < 3; i++) {
					// Make sure the maandlast is not below minimum
					var maandlast = Math.round((1 + (i * 0.5)) * checkMaandlast.apply(fields.leenbedrag, [fields.leenbedrag.value / 100]) * 100) / 100;
					var looptijd = Math.round(util.looptijd(fields.leenbedrag.value, fields.leenbedrag.product.calculator.values.nominaal, maandlast));

					var maandlastOptions = "";
					var looptijdOptions = "";

					looptijdOptions = looptijd + ' maanden';
					maandlastOptions = '€' + maandlast.toString().replace('.', ',') + ' p/m';

					looptijdOptions = util.equalString(looptijdOptions, 17);
					maandlastOptions = util.equalString(maandlastOptions, 17);

					looptijdOptions += '€' + maandlast.toString().replace('.', ',') + ' p/m';
					maandlastOptions += looptijd + ' maanden';

					looptijdOptions = util.equalString(looptijdOptions, 34);
					maandlastOptions = util.equalString(maandlastOptions, 34);

					//looptijdOptions += _this.perc.set(fields['rente'].value);
					looptijdOptions += _this.perc.set(fields['rente'].value -1)+" - "+_this.perc.set(fields['rente'].value +1);
					//maandlastOptions += _this.perc.set(fields['rente'].value);
                    maandlastOptions += _this.perc.set(fields['rente'].value -1)+" - "+_this.perc.set(fields['rente'].value +1);

					_this.dk.select.looptijd.options[looptijd] = looptijdOptions;
					_this.dk.select.maandlast.options[maandlast] = maandlastOptions;

					_this.dk.select.maandlast.values.push(maandlast);
					_this.dk.select.looptijd.values.push(looptijd);
				}

				if($('#offertearray-maandlast').val() != "" && $('#offertearray-maandlast').val() != undefined)
				{
					$('select#dk-maandlast').val($('#offertearray-maandlast').val()).trigger('change');

				}

				// _this.dk.select.looptijd.options = util.sortObject(_this.dk.select.looptijd.options);
				// _this.dk.select.maandlast.options = util.sortObject(_this.dk.select.maandlast.options);

				callback();
			},

			/**
			 * Holder for the maandlast select
			 * Get function returns the value of the selected option
			 * Set function loops through the options and selects the right on
			 */
			maandlast: {
				options: {},
				values: [],
				get: function(elm){
					return elm.val();
				},
				set: function(elm, value, fields){
					value = util.closestValueInArray(value, _this.dk.select.maandlast.values);
					elm.filter("select").children().remove();
					var options = util.objectToOptions(_this.dk.select.maandlast.options, value);
					elm.filter("select").html(util.objectToOptions(_this.dk.select.maandlast.options, value));
				}
			},

			/**
			 * Holder for the looptijd select
			 * Get function returns the value of the selected option
			 * Set function loops through the options and selects the right on
			 */
			looptijd: {
				options: {},
				values: [],
				get: function(elm){
					return elm.val();
				},
				set: function(elm, value, fields){
					value = util.closestValueInArray(value, _this.dk.select.looptijd.values);
					elm.filter("select").children().remove();
					var options = util.objectToOptions(_this.dk.select.looptijd.options, value);
					elm.filter("select").html(util.objectToOptions(_this.dk.select.looptijd.options, value));
				}
			}
		}
	}

	this.pl = {
		select: {
			generate: function(fields, callback){

				_this.pl.select.looptijd.options = {};
				_this.pl.select.maandlast.options = {};

				_this.pl.select.maandlast.values = []
				_this.pl.select.looptijd.values = [];

				var leenbedrag = fields.leenbedrag.value;
				var product = fields.looptijd.product.key;

				/*
				 * If type of woning is selected the rent will go up with 0.2 percent in some cases
				 * That's why type of woning is taken into account in util.getMaandlast
				 */
				if(fields.woning){
				    var woning = fields.woning.value;
				}else{
				    var woning = '1';
				}

				maxMonths = function()
				{
					if($('#productvorm').val() == "Persoonlijke lening senioren")
					{
						return 72;
					}else if($('#productvorm').val() == "Verbouwingskrediet" || $('#productvorm').val() == "Eigenhuis Persoonlijke lening")
					{
						return 120;
					}else{
						return 120;
					}
				}

				// Loop through the months
				for(var i = 0; i < config.pl.months.length; i++)
				{
					// Create new scope since we are going to do an Ajax request
					(function(i, _last){
						var j = i;
						var last = _last;

						util.getMaandlast(woning, product, leenbedrag, config.pl.months[j], function(rekenMaandlast, rente)
						{
							// Filter out some options
							if((leenbedrag >= 10000 || config.pl.months[j] <= 120) && config.pl.months[j] <= maxMonths())
							{
								rekenMaandlast = (Math.round(rekenMaandlast * 100) / 100);
								var maandlast = rekenMaandlast.toFixed(2).toString().replace('.', ',');
								// Give the money value's enough zero's at the end of their string
								maandlast = maandlast.split(',')[0] + ',' + maandlast.split(',')[1] + (maandlast.split(',')[1].length == 2 ? '' : '0');
								var maandlastOption = "";
								var looptijdOption = "";

								maandlastOption += '€' + maandlast + ' p/m ';
								maandlastOption = util.equalString(maandlastOption, 15);
								maandlastOption += config.pl.months[j] + ' maanden ';
								maandlastOption = util.equalString(maandlastOption, 32);
								//maandlastOption += _this.perc.set(rente); + ' rente';
                                maandlastOption += _this.perc.set(rente -1)+" - "+_this.perc.set(rente +1);

								looptijdOption += config.pl.months[j] + ' maanden ';
								looptijdOption = util.equalString(looptijdOption, 15);
								looptijdOption += '€' + maandlast + ' p/m ';
								looptijdOption = util.equalString(looptijdOption, 32);
								//looptijdOption += _this.perc.set(rente); + ' rente';
                                looptijdOption += _this.perc.set(rente -1)+" - "+_this.perc.set(rente +1);

								_this.pl.select.maandlast.values.push(rekenMaandlast);
								_this.pl.select.looptijd.values.push(config.pl.months[j]);
								_this.pl.select.maandlast.options[rekenMaandlast.toFixed(2)] = maandlastOption;
								_this.pl.select.looptijd.options[config.pl.months[j]] = looptijdOption;
							}

							if(last)
							{
								_this.pl.select.looptijd.options = util.sortObject(_this.pl.select.looptijd.options, true);
							 	//_this.pl.select.maandlast.options = util.sortObject(_this.pl.select.maandlast.options);
							 	if($('#offertearray-looptijd').val() != "" && $('#offertearray-looptijd').val() != undefined)
								{
									$('select#pl-looptijd').val($('#offertearray-looptijd').val()).trigger('change');

								}
								callback();
							}
						});
					})(i, i == config.pl.months.length - 1);
				}
			},
			maandlast: {
				options: {},
				values: [],
				get: function(elm){
					return elm.val();
				},
				set: function(elm, value, fields){
					value = util.closestValueInArray(value, _this.pl.select.maandlast.values);
					elm.filter("select").children().remove();
					var options = util.objectToOptions(_this.pl.select.maandlast.options, value);
					console.log(_this.pl.select.maandlast.options);
					elm.filter("select").html(util.objectToOptions(_this.pl.select.maandlast.options, value));
				}
			},
			looptijd: {
				options: {},
				values: [],
				get: function(elm){
					return elm.val();
				},
				set: function(elm, value, fields){
					value = util.closestValueInArray(value, _this.pl.select.looptijd.values);
					elm.filter("select").children().remove();
					var options = util.objectToOptions(_this.pl.select.looptijd.options, value);
					elm.filter("select").html(util.objectToOptions(_this.pl.select.looptijd.options, value));
				}
			}
		}
	}

	this.perc = {
		get: function(value){
			return Number(value.replace(',','.').replace('%', ''));
		},
		set: function(value){
			return (Math.round(value * 10) / 10).toString().replace('.',',') + '%';
		}
	}

	// 5.5 -> // 5,5%
	this.percentage = {
		get: function(elm){
			return _this.perc.get(elm.val());
		},
		set: function(elm, value){
			elm.val(_this.perc.set(value));
		}
	}

	this.percentageSpan = {
		get: function(elm){
			var values = elm.val().split(' - ');
			value = _this.percentage.get(values[0]) + 1;
			return value;
		},
		set: function(elm, value){
			elm.val(_this.perc.set((value - 1).toFixed(1)) + ' - ' + _this.perc.set((value + 1).toFixed(1)));
			/*
			 * Also set the hidden field value, to be send to leadsPoster
			 */
			elm.nextAll('input:hidden').eq(0).val(_this.perc.set((value - 1).toFixed(1)) + ' - ' + _this.perc.set((value + 1).toFixed(1)));
			elm.next().children('span.tooltip').children('span.tooltip-content').html("De exacte rente is afhankelijk van de terugkoppeling van de banken. In dit overzicht hebben we gerekend met het gemiddelde rentepercentage van "+_this.perc.set((value).toFixed(1))+".");
		}
	}

	this.percenatageBeneath = {
		get: function(elm) {
			// Not worth to return
		},
		set: function(elm, value) {
			$('.compare-table').next().children('.' + this.product.key.replace(' ', '-')).text(this.value.toString().replace('.', ',')+'%');
			callback();
		}
	}
}
